'use client';

import Script from 'next/script';
import { logEvent } from '../lib/analytics';
import { useLayoutEffect } from 'react';

declare global {
  interface Window {
    Tawk_API: any;
    Tawk_LoadStart: Date;
  }
}

const tawkToEvents = [
  'onChatMaximized',
  'onChatMinimized',
  'onChatHidden',
  'onChatStarted',
  'onChatEnded',
  'onPrechatSubmit',
  'onOfflineSubmit',
  'onChatMessageVisitor',
  'onChatMessageAgent',
  'onChatMessageSystem',
  'onAgentJoinChat',
  'onAgentLeaveChat',
  'onChatSatisfaction',
  'onFileUpload',
];

export const TawkTo: React.FC = () => {
  useLayoutEffect(() => {
    window.Tawk_API = {
      ...(window.Tawk_API || {}),
      ...tawkToEvents.reduce(
        (acc, eventName) => ({
          ...acc,
          [eventName]: () => logEvent({ category: 'tawk.to', name: eventName }),
        }),
        {},
      ),
    };
    window.Tawk_LoadStart = new Date();
  });

  // Tawk.to widget has domain restriction configured in their admin panel and won't run on localhost
  return (
    <Script
      id="tawk.to"
      src="https://embed.tawk.to/64d2d080cc26a871b02e1d95/1h7bnsta0"
      strategy="lazyOnload"
    />
  );
};
